export default {
  RADIO_OPTIONS: `RADIO_OPTIONS`,
  INFO: `INFO`,
  CONFIRM: `CONFIRM`,
  ERROR: `ERROR`,
  BUTTONS: `BUTTONS`,
  OPTIONS: `OPTIONS`,
  CUSTOM: `CUSTOM`,
};
